import { useEffect } from 'react';
import { Logger } from 'aws-amplify';
import { Setting } from '../models';

import { Settings, Key, query, createOrUpdate } from '../models/settings';
import Sequence, { setting as sequence } from './sequence';
import { Locale, setting as translation } from './translation';
import { nearest } from '../translation/book';
import Language from './localization';

const logger = new Logger('settings');

export function defaults(): Settings {
  const locale = Language.locale() as Locale;

  const result: Settings = {};
  result[sequence] = Sequence.EarlierHeaven;
  result[translation] = nearest(locale);
  return result;
}

// @todo any, export function useSettings(Settings: Settings, setSettings: (l: Dispatch<SetStateAction<Settings>>) => Settings){
// eslint-disable-next-line import/prefer-default-export
export function useSettings(settings: Settings, setSettings: (l: any) => void) {
  async function configure() {
    const current: Settings = defaults();
    const stored: Setting[] = await query();
    // eslint-disable-next-line array-callback-return
    stored.map((s) => {
      current[s.key] = s.value;
      logger.info(`setting ${s.key} queried with value ${s.value}`);
    });
    setSettings(current);
    logger.debug('settings updated');
  }

  useEffect(() => {
    // Time to add settings listeners or initialize settings
    configure();

    return () => {
      // Time to remove settings listeners or finalize settings
    };
  }, []);

  return {
    updateSetting: async (key: Key, value: string | number) => {
      const result = { ...settings };
      result[key] = value as string;
      setSettings(result);
      await createOrUpdate({ key, value: value as string });
    }
  };
}
